import { Component, computed, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { KunderService } from '@features/kunder/kunder.service';
import { KundeSearchParams } from '@features/kunder/kunde-search/kunde-search-params.model';
import { ScrollPanel } from 'primeng/scrollpanel';
import { LetInputCprComponent } from '@shared/let-input-cpr/let-input-cpr.component';

@Component({
  selector: 'app-kunde-search',
  imports: [
    ReactiveFormsModule,
    CheckboxModule,
    Button,
    InputText,
    Message,
    ScrollPanel,
    LetInputCprComponent
  ],
  templateUrl: './kunde-search.component.html',
  styleUrl: './kunde-search.component.css',
})
export class KundeSearchComponent {
  kundeService = inject(KunderService);
  data = this.kundeService.datasource.data;
  validationMessage = signal('');

  form = new FormGroup({
    navn: new FormControl(),
    cpr: new FormControl(),
    email: new FormControl(),
    fastnet: new FormControl(),
    mobil: new FormControl(),
    regnr: new FormControl(),
  });

  onClickSearch() {
    this.kundeService.searchKunde({
      ...(this.form.value as KundeSearchParams),
      searchTime: new Date(),
    });
  }

  onClickReset() {
    this.form.reset();
  }

  noHits = computed(() => {
    return (
      this.kundeService.datasource.isLoaded() && this.data()?.totalRowCount == 0
    );
  });
}
